'use strict';
var classof = require('../internals/classof-raw');
var wellKnownSymbol = require('../internals/well-known-symbol');

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  return it[ITERATOR] !== undefined
    || it['@@iterator'] !== undefined
    || classof(it) === 'Arguments';
};
